import React, { useState, useEffect } from 'react'
import {
  ButtonGroup,
  Checkbox,
  CheckPicker,
  Col,
  ControlLabel,
  Icon,
  IconButton,
  Input,
  InputGroup,
  Message,
  Panel,
  Row,
  SelectPicker,
  Uploader,
} from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import {
  getMaxLengthData,
  isImageOrPdf,
  isValidators,
  requiredFiled,
} from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import notification from '../../utils/notification'
import { cloneDeep, isEmpty } from 'lodash-es'
import ShowLimitLength from '../../components/utils/ShowLimitLength'

export default function InnovationFrom(props) {
  const {
    index,
    itemValue,
    onSubmit = () => {},
    onPreview = () => {},
    onDownload = () => {},
    onDelete = () => {},
    isSuccess,
  } = props
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()

  const [formSchema, setFormSchema] = useState(props.schema)
  const [creatorValue, setCreatorValue] = useState([])
  const [fileTypeError, setFileTypeError] = useState(false)
  const [fileCountError, setFileCountError] = useState(false)
  const [filesImage, setFilesImage] = useState([])
  const [fileLists, setFileLists] = useState([])
  const [mockBenefit, setMockBenefit] = useState('')
  const [detailVal, setDetailVal] = useState()
  const [benefitAcademicVal, setBenefitAcademicVal] = useState()
  const [benefitPolicyVal, setBenefitPolicyVal] = useState()
  const [benefitPublicVal, setBenefitPublicVal] = useState()
  const [benefitCommerceVal, setBenefitCommerceVal] = useState()

  const rowStyle = { marginTop: 5 }

  useEffect(() => {
    // console.log('itemValue.attachFiles => ', itemValue.attachFiles)

    let c = 0
    if (itemValue.benefitAcademic) {
      c++
    }
    if (itemValue.benefitCommerce) {
      c++
    }
    if (itemValue.benefitPolicy) {
      c++
    }
    if (itemValue.benefitPublic) {
      c++
    }
    setMockBenefit(c)

    setDetailVal(itemValue.detail || '')
    setBenefitAcademicVal(itemValue.benefitAcademicDetail || '')
    setBenefitPolicyVal(itemValue.benefitPolicyDetail || '')
    setBenefitPublicVal(itemValue.benefitPublicDetail || '')
    setBenefitCommerceVal(itemValue.benefitCommerceDetail || '')

    console.log('itemValue.attachFiles inno => ', itemValue.attachFiles)
    setFilesImage(itemValue.attachFiles)

    let newArr = []
    if (itemValue?.creator?.length > 0) {
      itemValue.creator.map((item, index) => {
        newArr.push(item)
      })
    } else {
      newArr.push('')
    }

    setCreatorValue(newArr)
  }, [itemValue])

  useEffect(() => {
    // console.log('isSuccess => ', isSuccess)
    if (isSuccess) {
      setFileLists([])

      setValue(formSchema.input.attachFiles.name, [])
    }
  }, [isSuccess])

  const addItemCreator = () => {
    const x = cloneDeep(creatorValue)

    let newArr = x || []
    newArr.push('')

    setCreatorValue(newArr)
  }

  const deleteItemCreator = (index, indexCreator) => {
    // console.log('deleteItemCreator ', indexCreator)

    const x = cloneDeep(creatorValue)
    x.splice(indexCreator, 1)

    setCreatorValue(x)
  }

  const setValueCreator = (index, indexCreator, value) => {
    // console.log(indexCreator, value)
    const x = cloneDeep(creatorValue)
    // console.log('xdata => ', x)

    x[indexCreator] = value
    // console.log('value => ', x)

    setCreatorValue(x)
  }

  const tableAttachFiles = (files) => {
    return (
      <table width={'100%'} border={1}>
        <thead>
          <tr>
            <th width="10%" style={{ textAlign: 'center' }}>
              <p style={{ padding: 3 }}>ลำดับ</p>
            </th>
            <th width="75%">
              <p style={{ padding: 3 }}>{`ไฟล์ (รวม ${filesImage?.length} ไฟล์)`}</p>
            </th>
            <th width="15%">
              <p style={{ padding: 3 }}>#</p>
            </th>
          </tr>
        </thead>
        <tbody>
          {filesImage?.map((item, index) => {
            return (
              <tr>
                <td align="center">{index + 1}</td>
                <td>
                  <p style={{ padding: 3 }}>{item.label}</p>
                </td>
                <td align="center">
                  <div style={{ padding: 3 }}>
                    <ButtonGroup>
                      <IconButton
                        appearance="ghost"
                        size="sm"
                        icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                        onClick={() => onPreview(item)}
                        // disabled={!item?.path}
                      />
                      <IconButton
                        appearance="ghost"
                        size="sm"
                        icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
                        onClick={() => onDownload(item)}
                        // disabled={!item?.path}
                      />
                      <IconButton
                        appearance="ghost"
                        size="sm"
                        className="rs-btn-ghost-cancel"
                        icon={<Icon icon="trash" className="bt-gost-icon-radius-cancel" />}
                        disabled={filesImage.length == 1}
                        onClick={() => onDelete(item, itemValue.id)}
                        // disabled={!item?.path}
                      />
                    </ButtonGroup>
                  </div>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    )
  }

  const handleChangeValBenefit = (bool, type) => {
    let x = cloneDeep(mockBenefit)

    switch (type) {
      case 'benefitAcademic':
        if (bool) {
          x++
        } else {
          x--
        }
        setMockBenefit(x)
        break

      case 'benefitPolicy':
        if (bool) {
          x++
        } else {
          x--
        }
        setMockBenefit(x)
        break

      case 'benefitPublic':
        if (bool) {
          x++
        } else {
          x--
        }
        setMockBenefit(x)
        break

      case 'benefitCommerce':
        if (bool) {
          x++
        } else {
          x--
        }
        setMockBenefit(x)
        break

      default:
        setMockBenefit(x)
        break
    }
  }

  return (
    <Panel
      // shaded
      collapsible
      defaultExpanded
      header={`${formSchema?.header || ''}ที่ ${index + 1}`}
      bordered
      key={index}
      style={{ marginBottom: 10 }}
    >
      <Row style={{ display: 'none' }}>
        <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
          Id :{' '}
        </Col>
        <Col lg={16} md={16} sm={16} xs={16}>
          <Input
            key={'id'}
            name={'id'}
            defaultValue={itemValue?.id || ''}
            value={itemValue?.id || ''}
            inputRef={register()}
          />
          <Input
            key={'progressId'}
            name={'progressId'}
            defaultValue={itemValue?.progressId || ''}
            value={itemValue?.progressId || ''}
            inputRef={register()}
          />
        </Col>
        <Col lg={2} md={2} sm={2} xs={2}></Col>
      </Row>
      <Row style={rowStyle}>
        <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
          <ControlLabel>
            {requiredFiled(formSchema.input.name.validators, formSchema.input.name.label)}
          </ControlLabel>
        </Col>
        <Col lg={16} md={16} sm={16} xs={16}>
          <ErrorMessage error={errors[`${formSchema.input.name.name}`]} />
          <Input
            key={`${formSchema.input.name.name}`}
            name={`${formSchema.input.name.name}`}
            defaultValue={itemValue.name || ''}
            disabled={formSchema.input.name.disabled}
            inputRef={register(isValidators(formSchema.input.name.validators))}
          />
        </Col>
        <Col lg={2} md={2} sm={2} xs={2}></Col>
      </Row>
      <Row style={rowStyle}>
        <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
          <ControlLabel>
            {requiredFiled(formSchema.input.detail.validators, formSchema.input.detail.label)}
          </ControlLabel>
        </Col>
        <Col lg={16} md={16} sm={16} xs={16}>
          <ErrorMessage error={errors[`${formSchema.input.detail.name}`]} />

          <Input
            key={index}
            componentClass="textarea"
            name={`${formSchema.input.detail.name}`}
            defaultValue={itemValue.detail || ''}
            disabled={formSchema.input.detail.disabled}
            inputRef={register(isValidators(formSchema.input.detail.validators))}
            maxLength={getMaxLengthData(formSchema.input.detail.validators)?.value}
            onChange={(value) => {
              setDetailVal(value)
            }}
          />
          <ShowLimitLength
            textLength={detailVal?.length || 0}
            maxLength={getMaxLengthData(formSchema.input.detail.validators)?.value}
          />
        </Col>
        <Col lg={2} md={2} sm={2} xs={2}></Col>
      </Row>
      <Row style={rowStyle}>
        <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
          <ControlLabel>
            {requiredFiled(
              formSchema.input.innovationType.validators,
              formSchema.input.innovationType.label
            )}
          </ControlLabel>
        </Col>
        <Col lg={16} md={16} sm={16} xs={16}>
          <ErrorMessage error={errors[`${formSchema.input.innovationType.name}`]} />
          <Controller
            key={`${formSchema.input.innovationType.name}`}
            name={`${formSchema.input.innovationType.name}`}
            control={control}
            defaultValue={itemValue.innovationType || ''}
            rules={isValidators(formSchema.input.innovationType.validators)}
            render={(props) => {
              return (
                <>
                  <SelectPicker
                    searchable
                    data={formSchema.input.innovationType.options || []}
                    value={props.value}
                    style={{ width: '100%' }}
                    placeholder="เลือก"
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  />

                  {props?.value == '7' && (
                    <div style={rowStyle}>
                      <ErrorMessage
                        error={
                          errors[`${formSchema.input.innovationType.otherInnovationType.name}`]
                        }
                      />
                      <Input
                        key={`${formSchema.input.innovationType.otherInnovationType.name}`}
                        name={`${formSchema.input.innovationType.otherInnovationType.name}`}
                        placeholder={`${formSchema.input.innovationType.otherInnovationType.label} ระบุ`}
                        defaultValue={itemValue.otherInnovationType || ''}
                        disabled={formSchema.input.innovationType.otherInnovationType.disabled}
                        inputRef={register(
                          isValidators(
                            formSchema.input.innovationType.otherInnovationType.validators
                          )
                        )}
                      />
                    </div>
                  )}
                </>
              )
            }}
          />
        </Col>
        <Col lg={2} md={2} sm={2} xs={2}></Col>
      </Row>
      <Row style={rowStyle}>
        <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
          <ControlLabel>
            {requiredFiled(formSchema.input.issue.validators, formSchema.input.issue.label)}
          </ControlLabel>
        </Col>
        <Col lg={16} md={16} sm={16} xs={16}>
          <ErrorMessage error={errors[`${formSchema.input.issue.name}`]} />
          <Controller
            key={`${formSchema.input.issue.name}`}
            name={`${formSchema.input.issue.name}`}
            control={control}
            defaultValue={itemValue?.issue || null}
            rules={isValidators(formSchema.input.issue.validators)}
            render={(props) => {
              return (
                <>
                  <CheckPicker
                    data={formSchema.input.issue.options || []}
                    value={props.value}
                    style={{ width: '100%' }}
                    placeholder="เลือก"
                    onChange={(value) => {
                      // console.log('value => ', value)
                      props.onChange(value)
                    }}
                  />

                  {props?.value?.find((item) => item == '9999-9999') && (
                    <div style={rowStyle}>
                      <ErrorMessage error={errors[`${formSchema.input.issue.otherIssue.name}`]} />
                      <Input
                        key={`${formSchema.input.issue.otherIssue.name}`}
                        name={`${formSchema.input.issue.otherIssue.name}`}
                        placeholder={`${formSchema.input.issue.otherIssue.label} ระบุ`}
                        defaultValue={itemValue.otherIssue || ''}
                        disabled={formSchema.input.issue.otherIssue.disabled}
                        inputRef={register(
                          isValidators(formSchema.input.issue.otherIssue.validators)
                        )}
                      />
                    </div>
                  )}
                </>
              )
            }}
          />
        </Col>
        <Col lg={2} md={2} sm={2} xs={2}></Col>
      </Row>
      <Row style={rowStyle}>
        <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
          <ControlLabel>
            {requiredFiled(formSchema.input.target.validators, formSchema.input.target.label)}
          </ControlLabel>
        </Col>
        <Col lg={16} md={16} sm={16} xs={16}>
          <ErrorMessage error={errors[`${formSchema.input.target.name}`]} />
          <Controller
            key={`${formSchema.input.target.name}`}
            name={`${formSchema.input.target.name}`}
            control={control}
            defaultValue={itemValue.target || null}
            rules={isValidators(formSchema.input.target.validators)}
            render={(props) => {
              return (
                <>
                  <CheckPicker
                    data={formSchema.input.target.options || []}
                    value={props.value}
                    style={{ width: '100%' }}
                    placeholder="เลือก"
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  />

                  {props?.value?.find((item) => item == '9999-9999') && (
                    <div style={rowStyle}>
                      <ErrorMessage error={errors[`${formSchema.input.target.otherTarget.name}`]} />
                      <Input
                        key={`${formSchema.input.target.otherTarget.name}`}
                        name={`${formSchema.input.target.otherTarget.name}`}
                        placeholder={`${formSchema.input.target.otherTarget.label} ระบุ`}
                        defaultValue={itemValue.otherTarget || ''}
                        disabled={formSchema.input.target.otherTarget.disabled}
                        inputRef={register(
                          isValidators(formSchema.input.target.otherTarget.validators)
                        )}
                      />
                    </div>
                  )}
                </>
              )
            }}
          />
        </Col>
        <Col lg={2} md={2} sm={2} xs={2}></Col>
      </Row>
      {creatorValue.length >= 0 &&
        creatorValue?.map((itemCreator, indexCreator) => {
          // console.log('itemCreator => ', itemCreator)
          return (
            <Row style={rowStyle}>
              <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
                <ControlLabel>
                  {requiredFiled(
                    formSchema.input.creator.validators,
                    `${formSchema.input.creator.label} (${indexCreator + 1})`
                  )}
                </ControlLabel>
              </Col>
              <Col lg={16} md={16} sm={16} xs={16}>
                {creatorValue[indexCreator]?.length <= 0 && (
                  <Message
                    type="error"
                    description={`${formSchema.input.creator.validators[0].errorMessage} (${
                      indexCreator + 1
                    })`}
                  />
                )}

                <ErrorMessage error={errors[`${formSchema.input.creator.name}[${indexCreator}]`]} />
                <InputGroup>
                  <Input
                    key={`${formSchema.input.creator.name}[${indexCreator}]`}
                    name={`${formSchema.input.creator.name}[${indexCreator}]`}
                    // defaultValue={formSchema.input.creator.value}
                    // defaultValue={itemCreator || ''}
                    value={itemCreator || null}
                    disabled={formSchema.input.creator.disabled}
                    inputRef={register(isValidators(formSchema.input.creator.validators))}
                    onChange={(value) => {
                      // console.log('val => ', indexCreator, value)
                      setValueCreator(index, indexCreator, value)
                    }}
                  />

                  {indexCreator == 0 ? (
                    <>
                      <InputGroup.Button
                        color="green"
                        // onClick={() => addItemCreator(itemCreator, indexCreator)}
                        onClick={() => addItemCreator(index, indexCreator)}
                      >
                        <Icon icon="plus-circle" />
                      </InputGroup.Button>
                    </>
                  ) : (
                    <>
                      <InputGroup.Button
                        color="red"
                        onClick={() => deleteItemCreator(index, indexCreator)}
                      >
                        <Icon icon="minus-circle" />
                      </InputGroup.Button>
                    </>
                  )}
                </InputGroup>
              </Col>
              <Col lg={2} md={2} sm={2} xs={2}></Col>
            </Row>
          )
        })}
      <Row style={rowStyle}>
        <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
          <ControlLabel>
            {requiredFiled(
              formSchema.input.yearOfDevelopment.validators,
              formSchema.input.yearOfDevelopment.label
            )}
          </ControlLabel>
        </Col>
        <Col lg={16} md={16} sm={16} xs={16}>
          <ErrorMessage error={errors[`${formSchema.input.yearOfDevelopment.name}`]} />
          <Controller
            key={`${formSchema.input.yearOfDevelopment.name}`}
            name={`${formSchema.input.yearOfDevelopment.name}`}
            control={control}
            defaultValue={
              itemValue.yearOfDevelopment ? itemValue.yearOfDevelopment.toString() : null
            }
            rules={isValidators(formSchema.input.yearOfDevelopment.validators)}
            render={(props) => {
              return (
                <SelectPicker
                  searchable
                  data={formSchema.input.yearOfDevelopment.options || []}
                  value={props.value}
                  style={{ width: '100%' }}
                  placeholder="เลือก"
                  onChange={(value) => {
                    props.onChange(value)
                  }}
                />
              )
            }}
          />
        </Col>
        <Col lg={2} md={2} sm={2} xs={2}></Col>
      </Row>
      <Row style={rowStyle}>
        <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
          <ControlLabel>
            {requiredFiled(
              formSchema.input.attachFiles.validators,
              formSchema.input.attachFiles.header
            )}
          </ControlLabel>
        </Col>
        <Col lg={16} md={16} sm={16} xs={16}>
          <br />

          {filesImage?.length <= 0 ||
            (isEmpty(filesImage) && (
              <Message
                style={{ marginTop: 10, marginBottom: 10 }}
                showIcon
                type="error"
                description={formSchema.input.attachFiles.description}
              />
            ))}

          {fileTypeError && (
            <Message
              style={{ marginTop: 10, marginBottom: 10 }}
              closable
              onClose={() => {
                setFileTypeError(false)
              }}
              showIcon
              type="error"
              description="อัพโหลดไฟล์เป็นรูปภาพเท่านั้น *** ชนิดที่รองรับ png , jpeg , jpg"
            />
          )}
          <ErrorMessage error={errors[`${formSchema.input.attachFiles.name}`]} />

          <Controller
            key={`${formSchema.input.attachFiles.name}`}
            name={`${formSchema.input.attachFiles.name}`}
            control={control}
            rules={isEmpty(filesImage) && isValidators(formSchema.input.attachFiles.validators)}
            defaultValue={undefined}
            render={(props) => {
              return (
                <>
                  <p style={{ fontSize: 'small', color: 'red' }}>{`  *อัปโหลดไฟล์ ชนิดที่รองรับ : ${
                    formSchema.input.attachFiles.fileType || '.jpg, .jpeg, .png'
                  } , ขนาดไฟล์ไม่เกิน ${formSchema.input.attachFiles.fileSize} MB`}</p>
                  <Uploader
                    accept={formSchema.input.attachFiles.fileType || '.jpg, .jpeg, .png'}
                    autoUpload={false}
                    disabled={filesImage?.length >= 10}
                    listType="picture-text"
                    fileList={fileLists || []}
                    multiple
                    onChange={(fileList) => {
                      const fl = fileList?.length || 0
                      const fi = filesImage?.length || 0

                      const countFile = fl + fi
                      if (countFile > 10) {
                        props.onChange(undefined)
                        setFileCountError(true)

                        notification.open('error', {
                          title: formSchema.input.attachFiles.description,
                          duration: 5000,
                        })

                        return false
                      }

                      if (isEmpty(fileList)) {
                        props.onChange(undefined)
                        setFileLists(undefined)
                      } else {
                        setFileLists(fileList)

                        fileList.map((_, index) => {
                          let file = fileList[index]

                          if (
                            file.blobFile.size >
                            formSchema?.input.attachFiles?.fileSize * 1024 * 1024
                          ) {
                            notification.open('error', {
                              title: `ขนาดไฟล์เกิน ${formSchema.input.attachFiles.fileSize} MB`,
                              duration: 5000,
                            })
                            return
                          }

                          if (isImageOrPdf(file.blobFile.type)) {
                            props.onChange(fileList)
                            setFileTypeError(false)
                          } else {
                            setFileTypeError(true)
                            notification.open('error', {
                              title:
                                'ชนิดที่รองรับ ' + formSchema.input.attachFiles.fileType ||
                                '.jpg, .jpeg, .png',
                              duration: 5000,
                            })
                          }
                        })
                      }
                    }}
                    draggable
                  >
                    <div>
                      <Icon size="2x" icon="upload2" />
                      <small className="uploder__text">{`   ${formSchema.input.attachFiles.description}`}</small>
                    </div>
                  </Uploader>
                </>
              )
            }}
          />
          {filesImage?.length > 0 && <div style={{ marginTop: 10 }}>{tableAttachFiles()}</div>}
          <br />
        </Col>
        <Col lg={2} md={2} sm={2} xs={2}></Col>
      </Row>
      <Row style={rowStyle}>
        <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
          <ControlLabel>
            {requiredFiled(
              formSchema.input.utilization.validators,
              formSchema.input.utilization.label
            )}
          </ControlLabel>
        </Col>
        <Col lg={16} md={16} sm={16} xs={16}>
          <ErrorMessage error={errors[`${formSchema.input.utilization.name}`]} />
          <Row style={{ display: 'none' }}>
            <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}></Col>
            <Col lg={16} md={16} sm={16} xs={16}>
              <Input
                key={`${formSchema.input.utilization.name}`}
                name={`${formSchema.input.utilization.name}`}
                placeholder={`${formSchema.input.utilization.label} ระบุ`}
                defaultValue={mockBenefit > 0 ? mockBenefit : ''}
                value={mockBenefit > 0 ? mockBenefit : ''}
                disabled={formSchema.input.utilization.disabled}
                inputRef={register(isValidators(formSchema.input.utilization.validators))}
              />
            </Col>
            <Col lg={2} md={2} sm={2} xs={2}></Col>
          </Row>

          <div style={{ marginBottom: 10 }}>
            <ErrorMessage error={errors[formSchema.input.benefitAcademic.name]} />
            <Controller
              name={formSchema.input.benefitAcademic.name}
              control={control}
              defaultValue={itemValue.benefitAcademic || false}
              render={(props) => {
                return (
                  <>
                    <Checkbox
                      onChange={(value, checked) => {
                        props.onChange(checked)
                        handleChangeValBenefit(checked, 'benefitAcademic')
                      }}
                      checked={props.value}
                    >
                      <p style={{ marginTop: -5 }}>{formSchema.input.benefitAcademic.label}</p>
                    </Checkbox>

                    {props.value && (
                      <div>
                        <ControlLabel>
                          {requiredFiled(
                            formSchema.input.benefitAcademic.benefitAcademicDetail.validators,
                            formSchema.input.benefitAcademic.benefitAcademicDetail.label
                          )}
                        </ControlLabel>
                        <ErrorMessage
                          error={
                            errors[`${formSchema.input.benefitAcademic.benefitAcademicDetail.name}`]
                          }
                        />
                        <Input
                          key={index}
                          name={`${formSchema.input.benefitAcademic.benefitAcademicDetail.name}`}
                          defaultValue={itemValue.benefitAcademicDetail || ''}
                          disabled={formSchema.input.benefitAcademic.benefitAcademicDetail.disabled}
                          componentClass="textarea"
                          inputRef={register(
                            isValidators(
                              formSchema.input.benefitAcademic.benefitAcademicDetail.validators
                            )
                          )}
                          maxLength={
                            getMaxLengthData(
                              formSchema.input.benefitAcademic.benefitAcademicDetail.validators
                            )?.value
                          }
                          onChange={(value) => {
                            setBenefitAcademicVal(value)
                          }}
                        />
                        <ShowLimitLength
                          textLength={benefitAcademicVal?.length || 0}
                          maxLength={
                            getMaxLengthData(
                              formSchema.input.benefitAcademic.benefitAcademicDetail.validators
                            )?.value
                          }
                        />
                      </div>
                    )}
                  </>
                )
              }}
            />
          </div>

          <div style={{ marginBottom: 10 }}>
            <ErrorMessage error={errors[formSchema.input.benefitPolicy.name]} />
            <Controller
              name={formSchema.input.benefitPolicy.name}
              control={control}
              defaultValue={itemValue.benefitPolicy || false}
              render={(props) => {
                return (
                  <>
                    <Checkbox
                      onChange={(value, checked) => {
                        props.onChange(checked)
                        handleChangeValBenefit(checked, 'benefitPolicy')
                      }}
                      checked={props.value}
                    >
                      <p style={{ marginTop: -5 }}>{formSchema.input.benefitPolicy.label}</p>
                    </Checkbox>

                    {props.value && (
                      <div>
                        <ControlLabel>
                          {requiredFiled(
                            formSchema.input.benefitPolicy.benefitPolicyDetail.validators,
                            formSchema.input.benefitPolicy.benefitPolicyDetail.label
                          )}
                        </ControlLabel>
                        <ErrorMessage
                          error={
                            errors[`${formSchema.input.benefitPolicy.benefitPolicyDetail.name}`]
                          }
                        />
                        <Input
                          key={index}
                          name={`${formSchema.input.benefitPolicy.benefitPolicyDetail.name}`}
                          defaultValue={itemValue.benefitPolicyDetail || ''}
                          disabled={formSchema.input.benefitPolicy.benefitPolicyDetail.disabled}
                          componentClass="textarea"
                          inputRef={register(
                            isValidators(
                              formSchema.input.benefitPolicy.benefitPolicyDetail.validators
                            )
                          )}
                          maxLength={
                            getMaxLengthData(
                              formSchema.input.benefitPolicy.benefitPolicyDetail.validators
                            )?.value
                          }
                          onChange={(value) => {
                            setBenefitPolicyVal(value)
                          }}
                        />
                        <ShowLimitLength
                          textLength={benefitPolicyVal?.length || 0}
                          maxLength={
                            getMaxLengthData(
                              formSchema.input.benefitPolicy.benefitPolicyDetail.validators
                            )?.value
                          }
                        />
                      </div>
                    )}
                  </>
                )
              }}
            />
          </div>

          <div style={{ marginBottom: 10 }}>
            <ErrorMessage error={errors[formSchema.input.benefitPublic.name]} />
            <Controller
              name={formSchema.input.benefitPublic.name}
              control={control}
              defaultValue={itemValue.benefitPublic || false}
              render={(props) => {
                return (
                  <>
                    <Checkbox
                      onChange={(value, checked) => {
                        props.onChange(checked)
                        handleChangeValBenefit(checked, 'benefitPublic')
                      }}
                      checked={props.value}
                    >
                      <p style={{ marginTop: -5 }}>{formSchema.input.benefitPublic.label}</p>
                    </Checkbox>

                    {props.value && (
                      <div>
                        <ControlLabel>
                          {requiredFiled(
                            formSchema.input.benefitPublic.benefitPublicDetail.validators,
                            formSchema.input.benefitPublic.benefitPublicDetail.label
                          )}
                        </ControlLabel>
                        <ErrorMessage
                          error={
                            errors[`${formSchema.input.benefitPublic.benefitPublicDetail.name}`]
                          }
                        />
                        <Input
                          key={index}
                          name={`${formSchema.input.benefitPublic.benefitPublicDetail.name}`}
                          defaultValue={itemValue.benefitPublicDetail || ''}
                          disabled={formSchema.input.benefitPublic.benefitPublicDetail.disabled}
                          componentClass="textarea"
                          inputRef={register(
                            isValidators(
                              formSchema.input.benefitPublic.benefitPublicDetail.validators
                            )
                          )}
                          maxLength={
                            getMaxLengthData(
                              formSchema.input.benefitPublic.benefitPublicDetail.validators
                            )?.value
                          }
                          onChange={(value) => {
                            setBenefitPublicVal(value)
                          }}
                        />
                        <ShowLimitLength
                          textLength={benefitPublicVal?.length || 0}
                          maxLength={
                            getMaxLengthData(
                              formSchema.input.benefitPublic.benefitPublicDetail.validators
                            )?.value
                          }
                        />
                      </div>
                    )}
                  </>
                )
              }}
            />
          </div>

          <div style={{ marginBottom: 10 }}>
            <ErrorMessage error={errors[formSchema.input.benefitCommerce.name]} />
            <Controller
              name={formSchema.input.benefitCommerce.name}
              control={control}
              defaultValue={itemValue.benefitCommerce || false}
              // value={isCancel}
              render={(props) => {
                return (
                  <>
                    <Checkbox
                      onChange={(value, checked) => {
                        props.onChange(checked)
                        handleChangeValBenefit(checked, 'benefitCommerce')
                      }}
                      checked={props.value}
                    >
                      <p style={{ marginTop: -5 }}>{formSchema.input.benefitCommerce.label}</p>
                    </Checkbox>

                    {props.value && (
                      <div>
                        <ControlLabel>
                          {requiredFiled(
                            formSchema.input.benefitCommerce.benefitCommerceDetail.validators,
                            formSchema.input.benefitCommerce.benefitCommerceDetail.label
                          )}
                        </ControlLabel>
                        <ErrorMessage
                          error={
                            errors[`${formSchema.input.benefitCommerce.benefitCommerceDetail.name}`]
                          }
                        />
                        <Input
                          key={index}
                          name={`${formSchema.input.benefitCommerce.benefitCommerceDetail.name}`}
                          defaultValue={itemValue.benefitCommerceDetail || ''}
                          disabled={formSchema.input.benefitCommerce.benefitCommerceDetail.disabled}
                          componentClass="textarea"
                          inputRef={register(
                            isValidators(
                              formSchema.input.benefitCommerce.benefitCommerceDetail.validators
                            )
                          )}
                          maxLength={
                            getMaxLengthData(
                              formSchema.input.benefitCommerce.benefitCommerceDetail.validators
                            )?.value
                          }
                          onChange={(value) => {
                            setBenefitCommerceVal(value)
                          }}
                        />
                        <ShowLimitLength
                          textLength={benefitCommerceVal?.length || 0}
                          maxLength={
                            getMaxLengthData(
                              formSchema.input.benefitCommerce.benefitCommerceDetail.validators
                            )?.value
                          }
                        />
                      </div>
                    )}
                  </>
                )
              }}
            />
          </div>
        </Col>
        <Col lg={2} md={2} sm={2} xs={2}></Col>
      </Row>
      <Row style={rowStyle}>
        <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
          <ControlLabel>
            {requiredFiled(formSchema.input.trlLevel.validators, formSchema.input.trlLevel.label)}
          </ControlLabel>
        </Col>
        <Col lg={16} md={16} sm={16} xs={16}>
          <ErrorMessage error={errors[`${formSchema.input.trlLevel.name}`]} />
          <Controller
            key={`${formSchema.input.trlLevel.name}`}
            name={`${formSchema.input.trlLevel.name}`}
            control={control}
            defaultValue={itemValue.trlLevel || ''}
            rules={isValidators(formSchema.input.trlLevel.validators)}
            render={(props) => {
              return (
                <SelectPicker
                  searchable
                  data={formSchema.input.trlLevel.options || []}
                  value={props.value}
                  style={{ width: '100%' }}
                  placeholder="เลือก"
                  onChange={(value) => {
                    props.onChange(value)
                  }}
                  virtualized={false}
                  renderMenuItem={(label, item) => {
                    return <span>{label}</span>
                  }}
                />
              )
            }}
          />
        </Col>
        <Col lg={2} md={2} sm={2} xs={2}></Col>
      </Row>
      <Row style={rowStyle}>
        <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
          <ControlLabel>
            {requiredFiled(formSchema.input.slrLevel.validators, formSchema.input.slrLevel.label)}
          </ControlLabel>
        </Col>
        <Col lg={16} md={16} sm={16} xs={16}>
          <ErrorMessage error={errors[`${formSchema.input.slrLevel.name}`]} />
          <Controller
            key={`${formSchema.input.slrLevel.name}`}
            name={`${formSchema.input.slrLevel.name}`}
            control={control}
            defaultValue={itemValue.slrLevel || ''}
            rules={isValidators(formSchema.input.slrLevel.validators)}
            render={(props) => {
              return (
                <SelectPicker
                  searchable
                  data={formSchema.input.slrLevel.options || []}
                  value={props.value}
                  style={{ width: '100%' }}
                  placeholder="เลือก"
                  onChange={(value) => {
                    props.onChange(value)
                  }}
                  virtualized={false}
                  renderMenuItem={(label, item) => {
                    return <span>{label}</span>
                  }}
                />
              )
            }}
          />
        </Col>
        <Col lg={2} md={2} sm={2} xs={2}></Col>
      </Row>
      <Row style={rowStyle}>
        <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
          {formSchema.input.detailMore.label}
        </Col>
        <Col lg={16} md={16} sm={16} xs={16}>
          <Input
            key={index}
            componentClass="textarea"
            name={formSchema.input.detailMore.name}
            defaultValue={itemValue.detailMore || ''}
            disabled={formSchema.input.detailMore.disabled}
            inputRef={register()}
          />
        </Col>
        <Col lg={2} md={2} sm={2} xs={2}></Col>
      </Row>

      <Row style={rowStyle}>
        <Col lg={24} md={24} sm={24} xs={24}>
          <hr />
          <p style={{ color: '#2da888', marginLeft: 15 }}>{formSchema.contactChannels.title}</p>
        </Col>
      </Row>
      <Row style={rowStyle}>
        <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
          <ControlLabel>
            {requiredFiled(
              formSchema.contactChannels.fullName.validators,
              formSchema.contactChannels.fullName.label
            )}
          </ControlLabel>
        </Col>
        <Col lg={16} md={16} sm={16} xs={16}>
          <ErrorMessage error={errors[`${formSchema.contactChannels.fullName.name}`]} />
          <Input
            key={`${formSchema.contactChannels.fullName.name}`}
            name={`${formSchema.contactChannels.fullName.name}`}
            defaultValue={itemValue.fullName || ''}
            disabled={formSchema.contactChannels.fullName.disabled}
            inputRef={register(isValidators(formSchema.contactChannels.fullName.validators))}
          />
        </Col>
        <Col lg={2} md={2} sm={2} xs={2}></Col>
      </Row>
      <Row style={rowStyle}>
        <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
          <ControlLabel>
            {requiredFiled(
              formSchema.contactChannels.email.validators,
              formSchema.contactChannels.email.label
            )}
          </ControlLabel>
        </Col>
        <Col lg={16} md={16} sm={16} xs={16}>
          <ErrorMessage error={errors[`${formSchema.contactChannels.email.name}`]} />
          <Input
            key={`${formSchema.contactChannels.email.name}`}
            name={`${formSchema.contactChannels.email.name}`}
            defaultValue={itemValue.email || ''}
            disabled={formSchema.contactChannels.email.disabled}
            inputRef={register(isValidators(formSchema.contactChannels.email.validators))}
          />
        </Col>
        <Col lg={2} md={2} sm={2} xs={2}></Col>
      </Row>
      <Row style={rowStyle}>
        <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
          <ControlLabel>
            {requiredFiled(
              formSchema.contactChannels.telephone.validators,
              formSchema.contactChannels.telephone.label
            )}
          </ControlLabel>
        </Col>
        <Col lg={16} md={16} sm={16} xs={16}>
          <ErrorMessage error={errors[`${formSchema.contactChannels.telephone.name}`]} />
          <Input
            key={`${formSchema.contactChannels.telephone.name}`}
            name={`${formSchema.contactChannels.telephone.name}`}
            type="number"
            defaultValue={itemValue.telephone || ''}
            disabled={formSchema.contactChannels.telephone.disabled}
            inputRef={register(isValidators(formSchema.contactChannels.telephone.validators))}
          />
        </Col>
        <Col lg={2} md={2} sm={2} xs={2}></Col>
      </Row>
      <Row style={rowStyle}>
        <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
          <ControlLabel>
            {requiredFiled(
              formSchema.contactChannels.agency.validators,
              formSchema.contactChannels.agency.label
            )}
          </ControlLabel>
        </Col>
        <Col lg={16} md={16} sm={16} xs={16}>
          <ErrorMessage error={errors[`${formSchema.contactChannels.agency.name}`]} />
          <Input
            key={`${formSchema.contactChannels.agency.name}`}
            name={`${formSchema.contactChannels.agency.name}`}
            defaultValue={itemValue.agency || ''}
            disabled={formSchema.contactChannels.agency.disabled}
            inputRef={register(isValidators(formSchema.contactChannels.agency.validators))}
          />
        </Col>
        <Col lg={2} md={2} sm={2} xs={2}></Col>
      </Row>

      <Row style={rowStyle}>
        <Col lg={24} md={24} sm={24} xs={24}>
          <hr />
          <p style={{ color: '#2da888', marginLeft: 15 }}>{formSchema.evaluationTitile}</p>
        </Col>
      </Row>
      <Row style={rowStyle}>
        <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
          <ControlLabel>
            {requiredFiled(formSchema.input.criteria1.validators, formSchema.input.criteria1.label)}
          </ControlLabel>
        </Col>
        <Col lg={16} md={16} sm={16} xs={16}>
          <ErrorMessage error={errors[`${formSchema.input.criteria1.name}`]} />
          <Controller
            key={`${formSchema.input.criteria1.name}`}
            name={`${formSchema.input.criteria1.name}`}
            control={control}
            defaultValue={itemValue.criteria1 ? itemValue.criteria1.toString() : null}
            rules={isValidators(formSchema.input.criteria1.validators)}
            render={(props) => {
              return (
                <SelectPicker
                  searchable={false}
                  data={formSchema.input.criteria1.options}
                  value={props.value}
                  block
                  placeholder="เลือก"
                  onChange={(value) => {
                    props.onChange(value)
                  }}
                />
              )
            }}
          />
        </Col>
        <Col lg={2} md={2} sm={2} xs={2}></Col>
      </Row>

      <Row style={rowStyle}>
        <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
          <ControlLabel>
            {requiredFiled(formSchema.input.criteria3.validators, formSchema.input.criteria3.label)}
          </ControlLabel>
        </Col>
        <Col lg={16} md={16} sm={16} xs={16}>
          <ErrorMessage error={errors[`${formSchema.input.criteria3.name}`]} />
          <Controller
            key={`${formSchema.input.criteria3.name}`}
            name={`${formSchema.input.criteria3.name}`}
            control={control}
            defaultValue={itemValue.criteria3 ? itemValue.criteria3.toString() : null}
            rules={isValidators(formSchema.input.criteria3.validators)}
            render={(props) => {
              return (
                <SelectPicker
                  searchable={false}
                  data={formSchema.input.criteria3.options}
                  value={props.value}
                  block
                  placeholder="เลือก"
                  onChange={(value) => {
                    props.onChange(value)
                  }}
                />
              )
            }}
          />
        </Col>
        <Col lg={2} md={2} sm={2} xs={2}></Col>
      </Row>

      <hr />
      <Row>
        <Col lg={24} md={24} sm={24} xs={24} style={{ marginBottom: 10 }}>
          {itemValue.typeSendFlag && itemValue.strSendFlag && (
            <div>
              <Message
                showIcon
                type={itemValue.typeSendFlag}
                // title={itemValue.strSendFlag}
                description={itemValue.strSendFlag}
              />
            </div>
          )}
        </Col>
        <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
          <SaveButton
            key={index}
            onClick={handleSubmit(onSubmit)}
            // disabled={isLoading || schema?.reviewerFilter?.disabled}
          >
            {formSchema.buttonText.saveButtonName}
          </SaveButton>
        </Col>
      </Row>
    </Panel>
  )
}
